import React from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, PointElement, LinearScale, Title, Tooltip, Legend, CategoryScale } from "chart.js";

// Chart.js öğelerini kaydet
ChartJS.register(LineElement, PointElement, LinearScale, Title, Tooltip, Legend, CategoryScale);

const ProductLineChart = ({ data }) => {

  const chartData = {
    labels: data?.labels || [],
    datasets: [
      {
        label: "Ürün Adedi",
        data: data?.values || [],
        fill: false,
        borderColor: "#05588C",
        tension: 0.1,
      },
    ],
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <Line data={chartData} />
    </div>
  );
};

export default ProductLineChart;
